import { BaseApiService } from '../../../api/base';
import type {
  Terms,
  TermsType,
  AnafTerms,
  LoanAnafTermsResponse,
  PartnerTerms,
} from '../types/terms';

class TermsApiService extends BaseApiService {
  public acceptById(id: string) {
    return this.post(`terms/${id}/accept`);
  }

  public getTerms(): Promise<Terms> {
    return this.get<Terms>('terms');
  }

  public getBcTerms(): Promise<Terms> {
    return this.get<Terms>('terms/bc-scoring');
  }

  public getAnafTerms(): Promise<AnafTerms> {
    return this.get<AnafTerms>('terms/anaf');
  }

  public acceptAnafTerms(): Promise<void> {
    return this.post<void>('terms/anaf/accept-terms');
  }

  public acceptBcTerms(): Promise<void> {
    return this.post<void>('terms/bc-scoring');
  }

  public hasAcceptedTerms(termsType: TermsType): Promise<boolean> {
    return this.get<boolean>(`terms/${termsType}/accepted`);
  }

  public getPartnerAnafTerms(): Promise<LoanAnafTermsResponse> {
    return this.get<LoanAnafTermsResponse>(`loans/offers/terms`);
  }

  public acceptPartnerAnafTerms(): Promise<void> {
    return this.post<void>(`loans/offers/terms/accept`, {});
  }

  public getPartnerTerms(): Promise<PartnerTerms> {
    return this.get<PartnerTerms>('wlc/partner/terms', {
      responseType: 'text',
      headers: { Accept: 'text/plain, text/html' },
      transformResponse: [(data) => data],
    });
  }
}

export const termsApiService = new TermsApiService();
